/**
 * Error code CS-00031: Account verification error
 * @type {string}
 * @constant
 */
export const CS_00031 = "CS-00031";

/**
 * Error code CS-00058: Specific error related to checkout process
 * @type {string}
 * @constant
 */
export const CS_00058 = "CS-00058";

/**
 * Error code CS-00071: Age requirement prompt for retirement goals
 * @type {string}
 * @constant
 */
export const CS_00071 = "CS-00071";

/**
 * Error code CTO-00001: Specific error related to summary transfer/switching
 * @type {string}
 * @constant
 */
export const CTO_00001 = "CTO-00001";

/**
 * Error code ETN-00002: Specific error related to electronic transactions
 * @type {string}
 * @constant
 */
export const ETN_00002 = "ETN-00002";

/**
 * Error code OE-00005: Specific error related to duplicate transactions
 * @type {string}
 * @constant
 */
export const OE_00005 = "OE-00005";

/**
 * Error code OE-00006: Specific error related to transaction timeout
 * @type {string}
 * @constant
 */
export const OE_00006 = "OE-00006";

/**
 * Error code POS-00001: Specific error related to point of sale transactions
 * @type {string}
 * @constant
 */
export const POS_00001 = "POS-00001";

/**
 * Error code TA-504: Specific error related to FNZ Timeout
 * @type {string}
 * @constant
 */
export const TA_504 = "TA-504";
